import { toast } from "sonner";

// Works on http (non-secure) origins too, where navigator.clipboard is unavailable.
export async function copyText(text, label = "کپی شد") {
  const value = String(text ?? "");
  let ok = false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      ok = true;
    }
  } catch {
    ok = false;
  }
  if (!ok) {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      ok = document.execCommand("copy");
    } catch {
      ok = false;
    }
    document.body.removeChild(ta);
  }
  if (ok) toast.success(label, { description: value, duration: 1800 });
  else toast.error("کپی انجام نشد");
}
